import React, { useState } from 'react';
import { Modal } from 'antd';
import { BarcodeScanner } from './BarcodeScanner';
import * as S from './styles';

type BarcodeScannerModalProps = {
    open: boolean;
    onClose: () => void;
    onDetected: (code: string) => void;
};

const ScannerContent = ({
    onClose,
    onDetected,
}: Omit<BarcodeScannerModalProps, 'open'>) => {
    const [hasCameraError, setHasCameraError] = useState(false);

    return (
        <>
            {hasCameraError ? (
                <S.ErrorMessage>
                    Não foi possível acessar a câmera. Verifique as permissões
                    do navegador e tente novamente.
                </S.ErrorMessage>
            ) : (
                <S.Viewport>
                    <BarcodeScanner
                        open
                        setCode={onDetected}
                        setOpen={(value) => {
                            if (!value) onClose();
                        }}
                        onError={() => setHasCameraError(true)}
                    />
                    <S.Corner $pos="tl" />
                    <S.Corner $pos="tr" />
                    <S.Corner $pos="bl" />
                    <S.Corner $pos="br" />
                    <S.ScanLine />
                </S.Viewport>
            )}
            <S.Hint>Aponte para o código de barras</S.Hint>
        </>
    );
};

export const BarcodeScannerModal = ({
    open,
    onClose,
    onDetected,
}: BarcodeScannerModalProps) => (
    <Modal
        title="Ler código de barras"
        open={open}
        onCancel={onClose}
        footer={null}
        destroyOnHidden
        width={480}
    >
        {open && <ScannerContent onClose={onClose} onDetected={onDetected} />}
    </Modal>
);

export default BarcodeScannerModal;
